module.exports = __webpack_public_path__ + "94ecc813d7f598a1dd25b8aa2e0a5dbd.MP3";